import _classCallCheck from "/home/solidaccount/public_html/frontend/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/solidaccount/public_html/frontend/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/home/solidaccount/public_html/frontend/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/home/solidaccount/public_html/frontend/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/solidaccount/public_html/frontend/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React__default from 'react';

var VisualElementHandler = /*#__PURE__*/function (_React__default$Compo) {
  _inherits(VisualElementHandler, _React__default$Compo);

  var _super = _createSuper(VisualElementHandler);

  function VisualElementHandler() {
    _classCallCheck(this, VisualElementHandler);

    return _super.apply(this, arguments);
  }

  _createClass(VisualElementHandler, [{
    key: "getSnapshotBeforeUpdate",
    value:
    /**
     * Update visual element props as soon as we know this update is going to be commited.
     */
    function getSnapshotBeforeUpdate() {
      var _this$props = this.props,
          visualElement = _this$props.visualElement,
          props = _this$props.props;
      if (visualElement) visualElement.setProps(props);
      return null;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {}
  }, {
    key: "render",
    value: function render() {
      return this.props.children;
    }
  }]);

  return VisualElementHandler;
}(React__default.Component);

export { VisualElementHandler };